<h5>{{ 'PURCHASERS.HEADER' | translate }}</h5>
<!-- Value: {{ formControl.value }} -->
<ag-grid-angular
  class="ag-theme-material grid"
  [gridOptions]="gridOptions"
  [rowData]="purchasersSignal()"
  [class.disabled]="formControl.disabled"
></ag-grid-angular>
